let CATEGORY_LIST = [];
let PARENT_CATEGORY_LIST = [];
let CHILD_CATEGORY_LIST = {}

export const init = (appInfo) => {
    CATEGORY_LIST = appInfo.categoryList;

    CATEGORY_LIST.map((item, idx) => {
        if (!item.parentCode) {
            PARENT_CATEGORY_LIST.push(item);
            if (!CHILD_CATEGORY_LIST[item.code]) {
                CHILD_CATEGORY_LIST[item.code] = [];
            }
        } else {
            if (!CHILD_CATEGORY_LIST[item.parentCode]) {
                CHILD_CATEGORY_LIST[item.parentCode] = [];
            }
            CHILD_CATEGORY_LIST[item.parentCode].push(item);
        }
    });
}
export const getParentCategoryList = _ => PARENT_CATEGORY_LIST;
export const getChildCategoryList = _ => CHILD_CATEGORY_LIST;
export const getCategory = code => {
    for(let i = 0 ; i < CATEGORY_LIST.length ; i++) {
        if(CATEGORY_LIST[i].code == code) {
            return CATEGORY_LIST[i];
        }
    }
}